import { Content } from 'src/contexts/ContentContext';
import { Button } from 'src/core/ui';
import { ContentId } from 'src/utils/constants/contentId';
import { useSwiper } from 'swiper/react';

import * as styles from '../EventHeader.css';

export function EventHeaderSidePanelSwiper({
  contentId,
}: {
  contentId: ContentId;
}) {
  const swiper = useSwiper();

  return (
    <Button
      variant="outline"
      onClick={() => swiper.slideNext()}
      className={styles.actionButton}
    >
      <Content id={contentId} />
    </Button>
  );
}
